<app-loader></app-loader>
<router-outlet></router-outlet>
<app-settings
  *ngIf="isSettingsModalOpen"
  closeMode="emit"
  (closed)="closeSettingsModal()">
</app-settings>
<app-notifications [isNotificationBarVisible]="false"></app-notifications>
<app-notification-empty-dropdown></app-notification-empty-dropdown>
  <div class="loader-overlay" *ngIf="isLoading">
    <div class="loader"></div>
  </div>
